import { __makeTemplateObject } from '../../_virtual/_tslib.js';
import styled from 'styled-components';

var AssignmentsDetailWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n"])));
var IconWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 3.8rem;\n  height: 3.8rem;\n  border: 1px solid ", ";\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  width: 3.8rem;\n  height: 3.8rem;\n  border: 1px solid ", ";\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray3;
});
var templateObject_1, templateObject_2;

export { AssignmentsDetailWrapper, IconWrapper };
